export const transformProductsData = (shopifyProducts) => {
  if (!shopifyProducts) return [];

  return shopifyProducts
    .filter(product => product.node.onlineStoreUrl)
    .map(product => {
      const variant = product.node.variants.edges[0].node;

      const price = Number(variant.price?.amount);
      const compareAtPrice = Number(variant.compareAtPrice?.amount);
      const regularPrice = compareAtPrice > 0 ? compareAtPrice : price;
      const salePrice = compareAtPrice > price ? price : null;

      const customImageRef = product.node.customFeaturedImage?.reference;
      const customImage = customImageRef?.image;
      const customPreview = customImageRef?.previewImage;
      const imageUrl = customImage?.url || customPreview?.url || product.node.featuredImage?.url;
      const imageAlt = customImage?.altText || product.node.title;


      return {
        href: `${product.node.onlineStoreUrl}?search`,
        picture: {
          src: imageUrl,
          alt: imageAlt
        },
        vendor: product.node.vendor,
        title: product.node.title,
        price: {
          regular: regularPrice,
          sale: salePrice,
          currency: 'PLN'
        }
      };
    })
    .slice(0, 30);
};
